import BaseGantt from "./shared/BaseGantt"
import React from "react"

const CustomGanttNurse = props => {
	return (
		<BaseGantt
			viewType="nurse"
			resourceId={props.nurseId}
			resourceName={props.nurseName}
			{...props}
		/>
	);
}

export default React.memo(CustomGanttNurse)